import actionTypes from '../constants/actionTypes';
import categories from '../constants/categories';

const initialState = [
  {
    name: 'Mein Wächter',
    categories: categories.map(category => ({
      ...category,
      active: true,
    })),
    radius: 20,
    active: true,
  },
];
export default function orteReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_ORT: {
      const newOrt = {
        subscriptionId: action.subscriptionId,
        name: action.name,
        categories: categories.map(category => ({
          ...category,
          active: true,
        })),
        coordinates: {
          lat: action.lat,
          lng: action.lng,
        },
        radius: action.radius,
        active: true,
      };
      return [...state, newOrt];
    }
    case actionTypes.REMOVE_ORT: {
      const id = parseInt(action.subscriptionId, 10);
      return state.filter(ort => parseInt(ort.subscriptionId, 10) !== id);
    }
    case actionTypes.SET_ORT_ACTIVE: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          active: action.state,
        };
      });
    }
    case actionTypes.SET_ORT_RADIUS: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          radius: action.radius,
        };
      });
    }
    case actionTypes.SET_ORT_CATEGORIES: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          categories: action.categories,
        };
      });
    }
    case actionTypes.SET_ORT_COORDINATES: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          coordinates: {
            lat: action.lat,
            lng: action.lng,
          },
        };
      });
    }
    case actionTypes.SET_ORT_SUBSCRIPTION_ID: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          subscriptionId: action.subscriptionId,
        };
      });
    }
    case actionTypes.SET_ORT_AREA: {
      return state.map(ort => {
        if (ort.name !== action.name) return ort;

        return {
          ...ort,
          area: action.area,
        };
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/orteReducer.js